<!-- ─── Header ──────────────────────────────────────────────────────────────── -->
<header class="iro-header">
  <h1 class="iro-header__title">Validazione IRO</h1>
  <div class="iro-header__divider" role="separator" aria-hidden="true"></div>
</header>

<!-- ─── Content ─────────────────────────────────────────────────────────────── -->
<div mat-dialog-content class="iro-dialog-content">
  <app-spinner-overlay />

  @if (inizializzato()) {
    <ng-scrollbar>
      @if (landingPageRaw()) {
        <div class="iro-landing-page" [innerHtml]="landingPage()"></div>
      }

      @for (sez of sezioni(); track sez.titolo; let idxSez = $index) {
        <section class="iro-section">
          <!-- Section Header -->
          <div class="iro-section__header">
            <div class="iro-section__step" aria-hidden="true">{{ idxSez + 1 }}</div>
            <h2 class="iro-section__title">{{ sez.titolo }}</h2>
          </div>

          <!-- Questions List -->
          <div class="iro-questions-list">
            @for (dom of sez.domande; track dom.id; let idxTem = $index) {
              <div class="iro-tema-container">
                <!-- Tematica banner -->
                @if ($any(dom).infoTematica && dom.metadati['tema']?.length) {
                  <div class="iro-tematica" [class.iro-tematica--spaced]="idxTem > 0">
                    <span class="iro-tematica__label">Tematica</span>
                    <span class="iro-tematica__text">{{ $any(dom).infoTematica }}</span>
                  </div>
                }

                @if (!dom.sottodomanda) {
                  <div class="iro-domanda-card">
                    <!-- ── IRO Accordion ─────────────────────────────────────── -->
                    @if (dom.metadati) {
                      <mat-accordion class="iro-accordion">
                        <mat-expansion-panel [expanded]="true" class="iro-expansion-panel">
                          <mat-expansion-panel-header class="iro-expansion-header">
                            <mat-panel-title class="iro-panel-title">
                              @if (dom.metadati['tema']?.length) {
                                <span class="iro-panel-title__badge">Tema</span>
                                {{ dom.metadati['tema'][0].nomeBreve }}
                              } @else {
                                <span class="iro-tematica__label">Tematica</span>
                                {{ $any(dom).infoTematica }}
                              }
                            </mat-panel-title>

                            <!-- Category count pills (visible in header) -->
                            <div class="iro-panel-pills" aria-hidden="true">
                              @if (dom.metadati['impatti']?.length) {
                                <span class="iro-pill iro-pill--impatti">
                                  ▲ {{ dom.metadati['impatti'].length }}
                                  <span class="iro-pill__label">Impatti</span>
                                </span>
                              }
                              @if (dom.metadati['rischi']?.length) {
                                <span class="iro-pill iro-pill--rischi">
                                  ⚠ {{ dom.metadati['rischi'].length }}
                                  <span class="iro-pill__label">Rischi</span>
                                </span>
                              }
                              @if (dom.metadati['opportunita']?.length) {
                                <span class="iro-pill iro-pill--opportunita">
                                  ✦ {{ dom.metadati['opportunita'].length }}
                                  <span class="iro-pill__label">Opportunità</span>
                                </span>
                              }
                            </div>
                          </mat-expansion-panel-header>

                          <!-- IRO Info Grid -->
                          <div class="iro-info-grid">
                            @if (dom.metadati['impatti']?.length) {
                              <div class="iro-category iro-category--impatti">
                                <div class="iro-category__header">
                                  <span class="iro-category__icon" aria-hidden="true">▲</span>
                                  <span class="iro-category__label">Impatti</span>
                                  <span class="iro-category__count">{{
                                    dom.metadati['impatti'].length
                                  }}</span>
                                </div>
                                <div class="iro-category__items">
                                  @for (impatto of dom.metadati['impatti']; track impatto.id) {
                                    <div class="iro-item">
                                      @if (impatto.titolo) {
                                        <span class="iro-item__title">{{ impatto.titolo }}</span>
                                      }
                                      <span class="iro-item__desc">{{ impatto.descrizione }}</span>
                                      @if (impatto.stringaDatiIro) {
                                        <div class="iro-item__data">
                                          {{ impatto.stringaDatiIro }}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }

                            @if (dom.metadati['rischi']?.length) {
                              <div class="iro-category iro-category--rischi">
                                <div class="iro-category__header">
                                  <span class="iro-category__icon" aria-hidden="true">⚠</span>
                                  <span class="iro-category__label">Rischi</span>
                                  <span class="iro-category__count">{{
                                    dom.metadati['rischi'].length
                                  }}</span>
                                </div>
                                <div class="iro-category__items">
                                  @for (rischio of dom.metadati['rischi']; track rischio.id) {
                                    <div class="iro-item">
                                      <span class="iro-item__desc">{{ rischio.descrizione }}</span>
                                      @if (rischio.stringaDatiIro) {
                                        <div class="iro-item__data">
                                          {{ rischio.stringaDatiIro }}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }

                            @if (dom.metadati['opportunita']?.length) {
                              <div class="iro-category iro-category--opportunita">
                                <div class="iro-category__header">
                                  <span class="iro-category__icon" aria-hidden="true">✦</span>
                                  <span class="iro-category__label">Opportunità</span>
                                  <span class="iro-category__count">{{
                                    dom.metadati['opportunita'].length
                                  }}</span>
                                </div>
                                <div class="iro-category__items">
                                  @for (opport of dom.metadati['opportunita']; track opport.id) {
                                    <div class="iro-item">
                                      <span class="iro-item__desc">{{ opport.descrizione }}</span>
                                      @if (opport.stringaDatiIro) {
                                        <div class="iro-item__data">
                                          {{ opport.stringaDatiIro }}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </mat-expansion-panel>
                      </mat-accordion>
                    }

                    <!-- ── Answer Section ────────────────────────────────────── -->
                    <div class="iro-risposta-wrapper">
                      <div class="iro-risposta-inner">
                        <!-- Question body -->
                        <div class="iro-risposta-body">
                          @switch (dom.tipo) {
                            @case ('scelta_multipla') {
                              <ng-container
                                [ngTemplateOutlet]="tplSceltaMultipla"
                                [ngTemplateOutletContext]="{ domanda: dom, idxSez, idxTem }"
                              />
                            }

                            @case ('scelta_singola') {
                              <mat-radio-group
                                class="iro-radio-group"
                                [value]="dom?.risposte?.length ? dom.risposte![0] : null"
                                (change)="onRadioChange($event, idxSez, idxTem)"
                                appFormContainer
                                [larghezza]="3"
                                [alignItems]="'center'"
                              >
                                <div class="cnt-radio-index">
                                  <!-- Question index badge -->
                                  <div class="iro-domanda-index" aria-hidden="true">
                                    {{ getDisplayIndex(idxTem, sez) }}
                                  </div>
                                  <div style="margin-top: 5px">
                                    <mat-label
                                      class="iro-domanda-label"
                                      [class.iro-domanda-label--error]="dom.valid === false"
                                      appFormElement
                                      [larghezza]="'auto'"
                                      [minWidth]="'auto'"
                                    >
                                      {{ dom.domanda }}
                                    </mat-label>

                                    <div class="iro-radio-options" appFormElement [larghezza]="3">
                                      @for (opz of dom.opzioni; track opz.chiave) {
                                        <mat-radio-button
                                          class="iro-radio-btn"
                                          [value]="opz.chiave"
                                          [disabled]="readOnly()"
                                          [class.is-valid]="opz.valore === 'Sì'"
                                          [class.is-invalid]="opz.valore === 'No'"
                                        >
                                          {{ opz.valore === 'No' ? 'Non valido' : 'Valido' }}
                                        </mat-radio-button>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <!-- Sottodomande della scelta singola -->
                                @for (opz of dom.opzioni; track opz.chiave) {
                                  @if (
                                    opz.objSottodomande?.length &&
                                    dom?.risposte?.length &&
                                    dom.risposte![0] === opz.chiave
                                  ) {
                                    <div class="iro-sottodomande">
                                      <div
                                        class="iro-sottodomande__header"
                                        aria-label="Domande di approfondimento"
                                      >
                                        <mat-icon class="iro-sottodomande__icon" aria-hidden="true"
                                          >subdirectory_arrow_right</mat-icon
                                        >
                                        <span class="iro-sottodomande__title"
                                          >Domande di approfondimento</span
                                        >
                                      </div>
                                      <div class="iro-sottodomande__list">
                                        @for (sotto of opz.objSottodomande; track sotto.id) {
                                          <div class="iro-sottodomanda-item">
                                            <ng-container
                                              [ngTemplateOutlet]="tplSceltaMultipla"
                                              [ngTemplateOutletContext]="{
                                                domanda: sotto,
                                                idxSez,
                                                idxTem: sotto.idxOriginale,
                                              }"
                                            />
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                }
                              </mat-radio-group>
                            }

                            @case ('testo') {
                              <ng-container
                                [ngTemplateOutlet]="tplLabelGuida"
                                [ngTemplateOutletContext]="{ dom }"
                              />
                              <mat-form-field
                                class="iro-form-field iro-form-field--full"
                                appFormElement
                                [larghezza]="3"
                              >
                                <mat-label>Risposta</mat-label>
                                <textarea
                                  matInput
                                  cdkTextareaAutosize
                                  cdkAutosizeMinRows="2"
                                  placeholder="Inserisci la tua risposta…"
                                  [(ngModel)]="dom.risposta"
                                  [disabled]="readOnly()"
                                ></textarea>
                                <mat-error appFormError />
                              </mat-form-field>
                            }

                            @case ('numero_intero') {
                              <ng-container
                                [ngTemplateOutlet]="tplCampoNumerico"
                                [ngTemplateOutletContext]="{ dom, step: 1 }"
                              />
                            }

                            @case ('numero_decimale') {
                              <ng-container
                                [ngTemplateOutlet]="tplCampoNumerico"
                                [ngTemplateOutletContext]="{ dom, step: 0.01 }"
                              />
                            }

                            @case ('data') {
                              <ng-container
                                [ngTemplateOutlet]="tplLabelGuida"
                                [ngTemplateOutletContext]="{ dom }"
                              />
                              <mat-form-field class="iro-form-field" appFormElement [larghezza]="1">
                                <mat-label>Data</mat-label>
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  [(ngModel)]="dom.data"
                                  [disabled]="readOnly()"
                                />
                                <mat-datepicker-toggle matIconSuffix [for]="picker" />
                                <mat-datepicker #picker />
                                <mat-error appFormError />
                              </mat-form-field>
                            }
                          }
                        </div>
                        <!-- /iro-risposta-body -->
                      </div>
                      <!-- /iro-risposta-inner -->
                    </div>
                    <!-- /iro-risposta-wrapper -->
                  </div>
                  <!-- /iro-domanda-card -->
                }
              </div>
              <!-- /iro-tema-container -->
            }
          </div>
          <!-- /iro-questions-list -->
        </section>
      }
    </ng-scrollbar>
  }
</div>

<!-- ─── Footer Actions ─────────────────────────────────────────────────────── -->
@if (!anteprima()) {
  <div
    mat-dialog-actions
    class="iro-dialog-actions"
    [ngStyle]="{ margin: isCompEsterna() ? '10px 0px' : '0' }"
  >
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
    @if (!readOnly()) {
      <button mat-flat-button color="primary" class="primary-button" (click)="salva()">
        Salva
      </button>
    }
  </div>
}

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- TEMPLATES                                                                   -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->

<!-- ─── Scelta Multipla ───────────────────────────────────────────────────── -->
<ng-template #tplSceltaMultipla let-domanda="domanda" let-idxSez="idxSez" let-idxTem="idxTem">
  <!-- Question text + validation error -->
  <div class="iro-multipla-header">
    <mat-label class="iro-domanda-label" appFormElement [larghezza]="3" [riempi]="true">
      {{ domanda.domanda }}
    </mat-label>

    @if (domanda.valid === false && !domanda.risposte?.length) {
      <p class="iro-error-msg" role="alert">
        <mat-icon class="iro-error-msg__icon">warning_amber</mat-icon>
        Selezionare almeno un IRO da revisionare
      </p>
    }
  </div>

  <section class="iro-checkbox-section" aria-label="Opzioni di selezione">
    <!-- Simple options: 2-column grid for scannability -->
    @if (domanda.opzioni?.length) {
      <div class="iro-checkbox-grid">
        @for (opz of domanda.opzioni; track opz.chiave) {
          <mat-checkbox
            class="iro-checkbox"
            [value]="opz.chiave"
            [checked]="checkSotto(domanda.risposte, opz.chiave)"
            (change)="cambioCheck($event, idxSez, idxTem, opz.chiave)"
            [disabled]="readOnly()"
          >
            {{ opz.valore }}
          </mat-checkbox>
        }
      </div>
    }

    <!-- Options with value (grouped by iroType) -->
    @for (opz of domanda.opzioniConValore; track opz.chiave; let idxOpz = $index) {
      @if (
        idxOpz === 0 ||
        (domanda.opzioniConValore[idxOpz - 1]?.metadati?.iroInfo?.length &&
          opz.metadati?.iroInfo?.length &&
          opz.metadati.iroInfo[0].iroType !==
            domanda.opzioniConValore[idxOpz - 1].metadati.iroInfo[0].iroType)
      ) {
        <div class="iro-gruppo-tipo">
          <span class="iro-gruppo-tipo__label">
            {{
              opz.metadati.iroInfo[0].iroType === 'opportunita'
                ? 'OPPORTUNITÀ'
                : (opz.metadati.iroInfo[0].iroType | uppercase)
            }}
          </span>
          <div class="iro-gruppo-tipo__line" aria-hidden="true"></div>
        </div>
      }

      <div class="iro-opzione-valore" appFormContainer [larghezza]="1">
        <mat-checkbox
          class="iro-checkbox"
          appFormElement
          [larghezza]="1"
          [riempi]="true"
          #iroCheck
          [value]="opz.chiave"
          [checked]="checkSotto(domanda.risposte, opz.chiave)"
          (change)="cambioCheck($event, idxSez, idxTem, opz.chiave)"
          [disabled]="readOnly()"
        >
          <span class="titolo-check-iro"> {{ opz.valore }}</span>
        </mat-checkbox>

        @if (iroCheck.checked) {
          <div class="iro-motivazione-wrapper">
            <mat-form-field
              class="iro-form-field iro-form-field--no-subscript"
              appFormElement
              [larghezza]="1"
              [riempi]="true"
            >
              <mat-label>Motivazione *</mat-label>
              <textarea
                matInput
                [(ngModel)]="opz.risposta"
                [disabled]="readOnly()"
                placeholder="Descrivi la motivazione…"
                rows="3"
                matTextareaAutosize
              >
              </textarea>
            </mat-form-field>

            @if (opz.valid === false && !opz.risposta) {
              <div class="iro-error-msg" role="alert">
                <mat-icon class="iro-error-msg__icon">warning_amber</mat-icon>
                Inserire una motivazione
              </div>
            }
          </div>
        }
      </div>
    }
  </section>
</ng-template>

<!-- ─── Campo Numerico ────────────────────────────────────────────────────── -->
<ng-template #tplCampoNumerico let-dom="dom" let-step="step">
  <ng-container [ngTemplateOutlet]="tplLabelGuida" [ngTemplateOutletContext]="{ dom }" />

  <div class="iro-numeric-row">
    @if (dom.idCategoriaUnitaDiMisura) {
      <mat-form-field
        class="iro-form-field iro-form-field--um"
        appFormElement
        [larghezza]="1"
        [riempi]="true"
      >
        <mat-label>Unità di Misura</mat-label>
        <mat-select [(ngModel)]="$any(dom.risposta).um" [disabled]="readOnly()">
          @for (um of arrayUm()[dom.idCategoriaUnitaDiMisura]; track um.id) {
            <mat-option [value]="um.id">{{ um.descrizione }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="iro-form-field iro-form-field--valore" appFormElement [larghezza]="1">
      <mat-label>Valore</mat-label>
      <input
        matInput
        [(ngModel)]="$any(dom.risposta).valore"
        type="number"
        [step]="step"
        appInputNumber
        [disabled]="readOnly()"
        placeholder="0"
      />
      <mat-error appFormError />
    </mat-form-field>
  </div>
</ng-template>

<!-- ─── Label + Linea Guida ───────────────────────────────────────────────── -->
<ng-template #tplLabelGuida let-dom="dom">
  <mat-label class="iro-domanda-label" appFormElement [larghezza]="3" [riempi]="true">
    {{ dom.domanda }}
  </mat-label>

  @if (dom?.metadati?.lineaGuida?.length) {
    <div class="iro-linea-guida" appFormElement [larghezza]="3" [riempi]="true" role="note">
      <mat-icon class="iro-linea-guida__icon" aria-hidden="true">info_outline</mat-icon>
      <span>{{ dom.metadati.lineaGuida[0] }}</span>
    </div>
  }
</ng-template>
